import React from 'react'
import { PopupBody, PopupBodySubHeadline } from './PopupBase'

type Props = {
  fontResizeRate: number;
}

const PopupIdendity12Types: React.FC<Props> = ({ fontResizeRate }) => {
  return (
    <div>
      <PopupBody fontResizeRate={fontResizeRate}>
        企業やブランドを12種類の人格に例え、その印象や特徴を把握するフレームワーク「ブランド・アーキタイプ」のイラストを制作しました。
        <br />
        人格に由来するキーワードや説明文から「このキャラクターは、どんな髪型を選びどんなアイテムを身につけているだろうか」とイメージを広げ、描きました。キャラクターの性別は各キーワードに由来する男性らしさ・女性らしさのイメージに囚われすぎず、なるべくフラットな感覚で男女６人ずつ割り振っています。ワークに対する理解が深まることを目指し、服装や持ち物を含めてその人格の「らしさ」がシンプルに滲み伝わるように仕上げました。
        <br /><br />
        Client：株式会社IDENTITY
      </PopupBody>
    </div>
  )
}

export default PopupIdendity12Types